<template>
    <section class="container">
        <side-menu/>
        <div class="coordinated-care">
            <div v-if="categories" v-for="category in categories">
                <h1>{{ category.title }}</h1>
                <div v-if="category.posts.length > 0">
                    <div class="card" v-for="post in category.posts">
                        <div class="img-wrapper">
                            <img :src="post.cover_image" @error="fixBrokenImage($event)"/>
                        </div>
                        <div class="wrapper">
                            <div class="text">
                                <h2>{{ post.title }}</h2>
                                <p>{{ post.description }}</p>
                            </div>
                            <div class="action">
                                <a v-if="post.attachment" :href="post.attachment" target="blank">Download</a>
                                <button v-else disabled>Indisponível</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="empty" v-else>
                    <p>Não há posts para essa categoria</p>
                </div>
            </div>

            <div class="empty" v-else>
                <p>Não há cuidados coordenados para exibir</p>
            </div>
        </div>
    </section>
</template>
<script>
    import {GET_COORDINATED_CARES, GET_CARE_FILES} from "../../services/coordinated_care";
    import noCover from '@/assets/images/no-cover.png';

    import {library} from '@fortawesome/fontawesome-svg-core'
    import {
        faExternalLinkAlt,
        faFileAlt
    } from '@fortawesome/free-solid-svg-icons'

    library.add(faExternalLinkAlt);
    library.add(faFileAlt);

    export default {
    name: "coordinated-care",
    props: {
        result: Object,
    },
    data() {
        return {
            categories: [],
            posts: {}
        };
    },
    methods: {
        fixBrokenImage(e){
            e.target.src = noCover;
        }
    },
    async beforeMount() {
        this.categories = await GET_COORDINATED_CARES();
        for (const category of this.categories) {
            for (const post of category.posts) {
                const { attachment, cover_image } = await GET_CARE_FILES(post.id);
                post.attachment = attachment;
                post.cover_image = cover_image || noCover;
            }
        }
    },
}
</script>
<style scoped>
  @import "./coordinated-care.scss";
  @import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/components/CoordinatedCare/CoordinatedCare.vue